import { createAction } from '@reduxjs/toolkit';
import { alertActions, patientActions } from '_actions';
import { diaryService, messageCenterService } from '_services';
import { ActionNames, Errors } from '_constants';

export const diaryActions = {
    showDiary: createAction(ActionNames.DIARY_SHOW),
    hideDiary: createAction(ActionNames.DIARY_HIDE),

    saveDiary: (ptno, diaryEntry, category, assignTo) => (dispatch) => {
        dispatch(diaryActions.saveDiaryRequest({ ptno }));

        diaryService.saveDiary(ptno, diaryEntry, category, assignTo)
            .then(
                () => {
                    dispatch(diaryActions.saveDiarySuccess(ptno));
                    dispatch(patientActions.loadDiary(ptno));
                    dispatch(alertActions.successMsg('Diary entry saved.'));
                }
                ,
                error => {
                    dispatch(diaryActions.saveDiaryFailure({ ptno: ptno, error: error }));
                    dispatch(alertActions.error(Errors.DIARY_SAVE_FAILURE));
                }
            );
    },
    saveDiaryRequest: createAction(ActionNames.DIARY_SAVE_REQUEST),
    saveDiarySuccess: createAction(ActionNames.DIARY_SAVE_SUCCESS),
    saveDiaryFailure: createAction(ActionNames.DIARY_SAVE_FAILURE),
    toggleIssue: createAction(ActionNames.DIARY_TOGGLE_ISSUE),



    load: () => dispatch => {
        dispatch(diaryActions.loadRequest());
        messageCenterService.loadDiaryItems()
            .then(
                messages => {
                    dispatch(diaryActions.loadSuccess(messages));
                },
                error => {
                    dispatch(diaryActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.DIARY_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.DIARY_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.DIARY_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.DIARY_LOAD_FAILURE),

    setSelectedMessage: createAction(ActionNames.DIARY_SET_SELECTED_MESSAGE),

    changeSelection: (dlno) => (dispatch, getState) => {
        dispatch(diaryActions.setSelectedMessage({ dlno }));


        if (!getState().entities.mcDiaryItems[dlno].isRead) {
            dispatch(diaryActions.markReadRequest({ dlno }));

            messageCenterService.markReadDiaryItem(dlno)
                .then(
                    () => { dispatch(diaryActions.markReadSuccess(dlno)) }
                    ,
                    error => {
                        dispatch(diaryActions.markReadFailure({ dlno, error }));
                        dispatch(alertActions.error(Errors.DIARY_MARK_READ_FAILURE));
                    }
                );
        }
    },
    markReadRequest: createAction(ActionNames.DIARY_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.DIARY_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.DIARY_MARK_READ_FAILURE),

    resolve: (dlno, resolveMsg) => dispatch => {
        dispatch(diaryActions.resolveRequest({ dlno }));

        messageCenterService.resolveDiaryItem(dlno, resolveMsg)
            .then(
                () => { dispatch(diaryActions.resolveSuccess(dlno)) }
                ,
                error => {
                    dispatch(diaryActions.resolveFailure({ dlno, error }));
                    dispatch(alertActions.error(Errors.DIARY_RESOLVE_FAILURE));
                }
            );
    },
    resolveRequest: createAction(ActionNames.DIARY_RESOLVE_REQUEST),
    resolveSuccess: createAction(ActionNames.DIARY_RESOLVE_SUCCESS),
    resolveFailure: createAction(ActionNames.DIARY_RESOLVE_FAILURE),

    toggleResolve: createAction(ActionNames.DIARY_TOGGLE_RESOLVE),




}
